import { FlagsComponentRouter } from 'flags'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['feature_learn-18453-hs-student-extension-activities'],
  OnComponent,
  OffComponent,
})

export default FlagToggler
